export default {
    tasks: [],
    totalTasks: 0,
    task: {},
    filteredBy: null,
};
